export const selectUser = (state) => state.trial.user;
export const selectEmailConfirmed = (state) => state.trial.emailConfirmed;
export const selectShowLoginModal = (state) => state.trial.showLoginModal;
export const selectShowCart = (state) => state.trial.showCart;
